module.exports = __webpack_public_path__ + "img/phone_1.0340a159.png";